import { SxProps } from "@mui/material";

export const linearProgressSx: SxProps = { position: "absolute", left: 0, bottom: -1, right: 0 };

export const appBarSx: SxProps = { mb: "30px" };

export const iconButtonSx: SxProps = { mr: 2 };

export const toolbarSx: SxProps = { display: "flex", justifyContent: "space-between" };
